import { EOfferStatusRequest, TStatusFilterOptionValue } from 'shared/types/offersHistory';
import { sendAnalytics } from 'shared/utils/analytics';

const STATUS_FILTER_MAP = {
  all: 'all',
  [EOfferStatusRequest.Published]: 'active',
  [EOfferStatusRequest.Deactivated]: 'archive',
};

export const trackStatusFilterChange = (value: TStatusFilterOptionValue) =>
  sendAnalytics({
    action: 'Click',
    label: 'history_offers_status',
    page: {
      extra: {
        status: STATUS_FILTER_MAP[value],
      },
    },
  });
